import { getI18nConfig } from 'aem-libs-react-ts/src/utils/getI18nConfig'

import cs from './i18n/cs.json'
import en from './i18n/en.json'

export default getI18nConfig({ cs, en })
